import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { NotExecutedHistoryItem } from 'src/app/model/history-item/not-executed-history-item';
import { _get } from '../../base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GetMostRecentNotExecutedHistoryItemControllerRequestService {
  private static BASE_URL = '/immo/getLatestNotExecutedHistoryItem';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) => res as NotExecutedHistoryItem;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      GetMostRecentNotExecutedHistoryItemControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getLatestNotExecutedHistoryItem(
    subProjectId: number
  ): Promise<NotExecutedHistoryItem> {
    return this.get(`/${subProjectId}`, this.deserialize).toPromise();
  }
}
